import { css } from 'linaria';

export const sponsoredHover = css`
  &:hover {
    background-color: var(--background-secondary);
  }
`;
